// extracted by mini-css-extract-plugin
export default {"Container":"DeviceParameters_Container__hXeeA","Placeholder":"DeviceParameters_Placeholder__K1MtP","Loading":"DeviceParameters_Loading__m-pkj"};